<template>
    <!-- PC各地mm群 -->
    <div class="regional-groups-page-pc">
        <ZhaiHeadPC class="zhai-head" />

        <div class="container errong">
            <div class="container-fluid mt-2">
                <!-- 二个按钮 -->
                <ZhaiTwoTuttonsPC />

                <!-- 标题 -->
                <div class="row shengse">
                    <div class="dixian px-3 py-2 d-flex justify-content-between align-items-center">
                        <div class="lf">
                            <i class="fa fa-female px5 LinkIcon"></i>
                            各地兼职mm群
                        </div>
                    </div>
                </div>
            </div>

            <!-- 列表页 -->
            <template v-if="!selectedPost">
                <div class="list-page-wrap" :class="{ 'masked-state': shouldShowListVipMask }">
                    <!-- 卡片区域 -->
                    <div class="row card-container mt-2">
                        <div class="col-md-4 mb-2" v-for="item in posts" :key="item.id">
                            <a @click.prevent="handleCardClick(item)" class="card-link">
                                <div class="card h-100">
                                    <div class="row g-0 h-100 card-inner-row">
                                        <div class="col-4 p-0 d-flex align-items-center justify-content-center">
                                            <div class="image-container">
                                                <img :src="item.img" :alt="item.name" class="card-img" />
                                            </div>
                                        </div>

                                        <div class="col-8 d-flex flex-column h-100">
                                            <div class="card-body p-1 d-flex flex-column h-100">
                                                <div class="header flex-shrink-0">
                                                    <h5 class="card-title mt-3">{{ item.name }}</h5>

                                                    <div class="ri mb-1 mt-2">
                                                        <div class="meta-item">
                                                            <i class="bi bi-clock"></i>
                                                            <span>{{ formatDate(item.createTime) }}</span>
                                                        </div>
                                                        <div class="meta-item">
                                                            <i class="bi bi-star-fill"></i>
                                                            <span>{{ item.collectCount }}收藏</span>
                                                        </div>
                                                        <div class="meta-item">
                                                            <i class="bi bi-eye"></i>
                                                            <span>{{ item.viewCount || "1.2万" }}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="content flex-grow-1">
                                                    <p class="card-text">{{ item.history }}</p>
                                                </div>

                                                <div class="footer mb-2 flex-shrink-0">
                                                    <span class="bi bi-send-fill weiz changlv">
                                                        &nbsp;{{ item.province }}-{{ item.city }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>

                    <!-- 分页 -->
                    <div
                            class="bg-white my-2 p-3 G-Field text-center d-flex justify-content-center align-items-center pagination-wrap"
                    >
                        <button
                                class="custom-page-btn"
                                @click="goFirstPage"
                                :disabled="pageNum === 1"
                        >
                            首页
                        </button>

                        <button
                                class="custom-page-btn"
                                @click="prevPage"
                                :disabled="pageNum === 1"
                        >
                            上一页
                        </button>

                        <span class="page-number-box">
                            第 {{ pageNum }} 页，共 {{ totalPages }} 页
                        </span>

                        <button
                                class="custom-page-btn"
                                @click="nextPage"
                                :disabled="pageNum === totalPages"
                        >
                            下一页
                        </button>
                    </div>
                </div>

                <!-- PC列表页权限遮罩 -->
                <div
                        v-if="shouldShowListVipMask"
                        class="vip-mask-overlay pc-list-mask-overlay"
                        @click.self="handleMaskClick"
                >
                    <div class="vip-mask-dialog">
                        <div class="vip-mask-content">
                            <!--<div class="vip-mask-badge">VIP CONTENT</div>-->

                            <div class="vip-mask-title">
                                {{ maskTitle }}
                            </div>

                            <div class="vip-mask-text">
                                {{ maskText }}
                            </div>

                            <template v-if="!isLoggedIn">
                                <div class="mask-link-row">
                                    <router-link to="/login" class="vip-mask-link-btn">
                                        点击登录
                                    </router-link>
                                    <router-link to="/register" class="vip-mask-link-btn secondary">
                                        点击注册
                                    </router-link>
                                </div>
                            </template>

                            <template v-else>
                                <router-link to="/upgradeVIP" class="vip-upgrade-link-btn">
                                    点击升级VIP
                                </router-link>
                            </template>

                            <div class="vip-mask-back" @click="handleMaskClose">
                                返回首页
                            </div>
                        </div>
                    </div>
                </div>
            </template>

            <!-- 详情页 -->
            <template v-else>
                <div class="detail-wrap mt-2">
                    <div class="detail-card bg-white">
                        <div class="detail-title-box">
                            <h2 class="detail-title">{{ selectedPost.name }}</h2>
                        </div>

                        <div class="detail-user-row d-flex justify-content-between align-items-center">
                            <div class="detail-user-left d-flex align-items-center">
                                <img :src="selectedPost.avatar" class="avatar" alt="头像" />
                                <div class="user-meta">
                                    <div class="user-name">{{ selectedPost.author }}</div>
                                    <div class="user-date">{{ formatDate(selectedPost.createTime) }}</div>
                                </div>
                            </div>

                            <button class="collect-btn" type="button" @click="toggleCollect">
                                <i class="bi" :class="isCollected ? 'bi-heart-fill' : 'bi-heart'"></i>
                                {{ isCollected ? '已收藏' : '收藏' }}
                            </button>
                        </div>

                        <div class="detail-meta-wrap">
                            <div class="detail-meta-item">
                                <span class="detail-meta-label">所属地区：</span>
                                <span>{{ selectedPost.province }} - {{ selectedPost.city }}</span>
                            </div>
                            <div class="detail-meta-item">
                                <span class="detail-meta-label">收藏数量：</span>
                                <span>{{ selectedPost.collectCount }}</span>
                            </div>
                            <div class="detail-meta-item">
                                <span class="detail-meta-label">浏览次数：</span>
                                <span>{{ selectedPost.viewCount || "1.2万" }}</span>
                            </div>
                        </div>

                        <div class="detail-content">
                            <p class="detail-paragraph">{{ selectedPost.detail }}</p>
                            <p class="detail-paragraph" v-if="selectedPost.notice">{{ selectedPost.notice }}</p>
                            <p class="detail-paragraph" v-if="selectedPost.extra">{{ selectedPost.extra }}</p>
                        </div>

                        <div class="copy-share" @click="copyShareText(selectedPost)">
                            复制分享
                        </div>
                    </div>

                    <div class="text-center my-3">
                        <button class="btn btn-secondary back-btn" @click="backToList">
                            返回列表
                        </button>
                    </div>
                </div>
            </template>
        </div>

        <!-- Toast -->
        <transition name="fade">
            <div v-if="toast.show" class="toast-box" :class="toast.type">
                <i
                        class="bi me-1"
                        :class="toast.type === 'success' ? 'bi-emoji-smile' : 'bi-emoji-frown'"
                ></i>
                <span>{{ toast.message }}</span>
            </div>
        </transition>

        <ZhaiFootPC />
    </div>
</template>

<script>
    import ZhaiHeadPC from "../componentspc/ZhaiHeadPC";
    import ZhaiFootPC from "../componentspc/ZhaiFootPC";
    import ZhaiTwoTuttonsPC from "../componentspc/ZhaiTwoTuttonsPC";

    export default {
        name: "PRegionalGroups",
        components: {
            ZhaiHeadPC,
            ZhaiFootPC,
            ZhaiTwoTuttonsPC
        },
        data() {
            return {
                posts: [],
                pageNum: 1,
                pageSize: 6,
                totalPages: 1,
                selectedPost: null,
                isCollected: false,
                toastTimer: null,
                toast: {
                    show: false,
                    message: "",
                    type: "success"
                },
                mockPosts: [
                    {
                        id: 1,
                        name: "各地群组",
                        author: "匿名用户",
                        createTime: "2025-11-03 10:21:00",
                        collectCount: 12,
                        viewCount: "1.8万",
                        province: "广东",
                        city: "深圳",
                        history: "近期腾讯风控严重，多数群组已经被封，正在重新组建中，请耐心等待。",
                        detail: "近期腾讯风控严重，多数群组已经被封，正在重新组建中，请耐心等待。",
                        notice: "本页内容仅供内部整理使用，请谨慎甄别群内信息，避免误入异常入口。",
                        extra: "后续若有新的可用入口，将优先同步到本页。",
                        img: "https://dummyimage.com/300x400/f3f3f3/333&text=%E5%90%84%E5%9C%B0%E7%BE%A4%E7%BB%84",
                        avatar: "https://dummyimage.com/80x80/f2c200/ffffff&text=%E5%8C%BF"
                    },
                    {
                        id: 2,
                        name: "深圳兼职群",
                        author: "匿名用户",
                        createTime: "2025-11-04 09:18:00",
                        collectCount: 8,
                        viewCount: "2.1万",
                        province: "天津",
                        city: "滨海",
                        history: "深圳本地兼职信息整理中，群链接暂未恢复，请稍后再看。",
                        detail: "深圳本地兼职信息整理中，群链接暂未恢复，请稍后再看。",
                        notice: "如遇提前收费、押金、认证费等情况，请立即退出。",
                        extra: "建议优先查看近三日更新内容。",
                        img: "https://dummyimage.com/300x400/ededed/333&text=%E6%B7%B1%E5%9C%B3%E5%85%BC%E8%81%8C%E7%BE%A4",
                        avatar: "https://dummyimage.com/80x80/f2c200/ffffff&text=%E5%8C%BF"
                    },
                    {
                        id: 3,
                        name: "广州兼职群",
                        author: "匿名用户",
                        createTime: "2025-11-05 08:22:00",
                        collectCount: 10,
                        viewCount: "2.8万",
                        province: "广东",
                        city: "广州",
                        history: "广州兼职资源正在更新，原群失效，等待新群开放。",
                        detail: "广州兼职资源正在更新，原群失效，等待新群开放。",
                        notice: "请不要向陌生账号透露真实住址、联系方式与付款信息。",
                        extra: "近期新增多个临时过渡群，时效较短。",
                        img: "https://dummyimage.com/300x400/e9e9e9/333&text=%E5%B9%BF%E5%B7%9E%E5%85%BC%E8%81%8C%E7%BE%A4",
                        avatar: "https://dummyimage.com/80x80/f2c200/ffffff&text=%E5%8C%BF"
                    },
                    {
                        id: 4,
                        name: "杭州兼职群",
                        author: "匿名用户",
                        createTime: "2025-11-06 14:40:00",
                        collectCount: 5,
                        viewCount: "9800",
                        province: "浙江",
                        city: "杭州",
                        history: "杭州群组正在维护中，资料暂未完全同步。",
                        detail: "杭州群组正在维护中，资料暂未完全同步。",
                        notice: "请留意更新时间，过期入口可能已无法访问。",
                        extra: "预计近期会补充更多可用内容。",
                        img: "https://dummyimage.com/300x400/efefef/333&text=%E6%9D%AD%E5%B7%9E%E5%85%BC%E8%81%8C%E7%BE%A4",
                        avatar: "https://dummyimage.com/80x80/f2c200/ffffff&text=%E5%8C%BF"
                    },
                    {
                        id: 5,
                        name: "上海兼职群",
                        author: "匿名用户",
                        createTime: "2025-11-07 11:15:00",
                        collectCount: 16,
                        viewCount: "3.4万",
                        province: "上海",
                        city: "上海",
                        history: "上海兼职信息较多，正在筛选整理，请持续关注。",
                        detail: "上海兼职信息较多，正在筛选整理，请持续关注。",
                        notice: "平台仅做汇总展示，具体内容请自行判断真伪。",
                        extra: "当前入口变动较快，建议优先查看最新发布。",
                        img: "https://dummyimage.com/300x400/f5f5f5/333&text=%E4%B8%8A%E6%B5%B7%E5%85%BC%E8%81%8C%E7%BE%A4",
                        avatar: "https://dummyimage.com/80x80/f2c200/ffffff&text=%E5%8C%BF"
                    },
                    {
                        id: 6,
                        name: "北京兼职群",
                        author: "匿名用户",
                        createTime: "2025-11-08 16:08:00",
                        collectCount: 6,
                        viewCount: "1.1万",
                        province: "北京",
                        city: "朝阳",
                        history: "北京群组暂未开放，请等待管理员重新分发。",
                        detail: "北京群组暂未开放，请等待管理员重新分发。",
                        notice: "请勿轻信私下交易与保证金要求。",
                        extra: "管理员整理完成后会同步开放新入口。",
                        img: "https://dummyimage.com/300x400/f0f0f0/333&text=%E5%8C%97%E4%BA%AC%E5%85%BC%E8%81%8C%E7%BE%A4",
                        avatar: "https://dummyimage.com/80x80/f2c200/ffffff&text=%E5%8C%BF"
                    }
                ]
            };
        },
        computed: {
            isLoggedIn() {
                const getters = this.$store?.getters || {};
                if (typeof getters.isLoggedIn === "boolean") return getters.isLoggedIn;
                return false;
            },
            getUser() {
                const getters = this.$store?.getters || {};
                return getters.getUser || null;
            },
            isPermanentVip() {
                if (!this.isLoggedIn) return false;
                const level = String(this.getUser?.level || "").trim();
                return level.includes("永久会员") || level.includes("永久至尊VIP");
            },
            canViewRegionalGroups() {
                return this.isLoggedIn && this.isPermanentVip;
            },
            shouldShowListVipMask() {
                return !this.selectedPost && !this.canViewRegionalGroups;
            },
            maskTitle() {
                return this.isLoggedIn ? "您没有权限访问该内容" : "请先登录后查看";
            },
            maskText() {
                return this.isLoggedIn
                    ? "此内容仅对永久至尊VIP开放，请升级后继续查看。"
                    : "登录或注册账号后，才可以继续访问该内容。";
            }
        },
        mounted() {
            this.fetchPosts();
        },
        methods: {
            formatDate(value) {
                if (!value) return "";
                return String(value).slice(0, 10);
            },
            fetchPosts() {
                const start = (this.pageNum - 1) * this.pageSize;
                const end = start + this.pageSize;
                this.posts = this.mockPosts.slice(start, end);
                this.totalPages = Math.ceil(this.mockPosts.length / this.pageSize) || 1;
            },
            goFirstPage() {
                this.pageNum = 1;
                this.fetchPosts();
                this.scrollTop();
            },
            prevPage() {
                if (this.pageNum > 1) {
                    this.pageNum--;
                    this.fetchPosts();
                    this.scrollTop();
                }
            },
            nextPage() {
                if (this.pageNum < this.totalPages) {
                    this.pageNum++;
                    this.fetchPosts();
                    this.scrollTop();
                }
            },
            handleCardClick(post) {
                if (!this.canViewRegionalGroups) {
                    this.showToast(this.isLoggedIn ? "仅永久会员可查看" : "请先登录", "error");
                    return;
                }

                this.selectedPost = JSON.parse(JSON.stringify(post));
                this.isCollected = false;
                this.scrollTop();
            },
            backToList() {
                this.selectedPost = null;
                this.isCollected = false;
                this.scrollTop();
            },
            handleMaskClick() {
                // 点击空白区域不关闭，保持与手机端一致
            },
            handleMaskClose() {
                this.$router.push("/");
            },
            scrollTop() {
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            },
            toggleCollect() {
                if (!this.isLoggedIn) {
                    this.showToast("请先登录", "error");
                    return;
                }

                this.isCollected = !this.isCollected;
                this.showToast(this.isCollected ? "收藏成功" : "已取消收藏", "success");
            },
            async copyShareText(post) {
                if (!this.canViewRegionalGroups) {
                    this.showToast("当前无权限复制内容", "error");
                    return;
                }

                const text =
                    `${post.name}\n` +
                    `发布时间：${this.formatDate(post.createTime)}\n` +
                    `地区：${post.province}-${post.city}\n` +
                    `${post.detail}\n` +
                    `${post.notice || ""}\n` +
                    `${post.extra || ""}`;

                try {
                    if (navigator.clipboard && window.isSecureContext) {
                        await navigator.clipboard.writeText(text);
                    } else {
                        const textarea = document.createElement("textarea");
                        textarea.value = text;
                        textarea.style.position = "fixed";
                        textarea.style.left = "-9999px";
                        textarea.style.top = "0";
                        document.body.appendChild(textarea);
                        textarea.focus();
                        textarea.select();
                        document.execCommand("copy");
                        document.body.removeChild(textarea);
                    }

                    this.showToast("已复制分享内容", "success");
                } catch (e) {
                    this.showToast("复制失败，请手动复制", "error");
                }
            },
            showToast(message, type = "success") {
                this.toast.show = true;
                this.toast.message = message;
                this.toast.type = type;

                if (this.toastTimer) {
                    clearTimeout(this.toastTimer);
                }

                this.toastTimer = setTimeout(() => {
                    this.toast.show = false;
                }, 2000);
            }
        },
        beforeUnmount() {
            if (this.toastTimer) {
                clearTimeout(this.toastTimer);
                this.toastTimer = null;
            }
        }
    };
</script>

<style scoped>
    .regional-groups-page-pc {
        min-height: 100vh;
        background: #f5f5f5;
    }

    .bi {
        margin-right: 2px;
    }

    .list-page-wrap {
        position: relative;
        transition: all 0.2s ease;
    }

    .masked-state .card-container,
    .masked-state .pagination-wrap,
    .masked-state .shengse {
        filter: blur(4px);
        user-select: none;
        pointer-events: none;
    }

    /* 头部 */
    .dixian {
        background: #ffffff;
        border-bottom: 1px solid #efefef;
        color: #222;
        font-size: 16px;
    }

    .lf {
        font-size: 16px;
        color: #222;
        font-weight: 500;
    }

    /* 卡片 */
    .card-container {
        margin-left: -6px;
        margin-right: -6px;
    }

    .card-container > div[class*="col-"] {
        padding-left: 6px;
        padding-right: 6px;
    }

    .card {
        text-decoration: none;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
        border: 1px solid #f0f0f0;
        cursor: pointer !important;
        background: #fff;
        overflow: hidden;
        border-radius: 10px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }

    .card:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
    }

    .card-inner-row {
        flex-wrap: nowrap;
    }

    .col-4 {
        width: 115px;
        min-width: 115px;
        max-width: 115px;
        height: 155px;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        padding: 0;
        flex: 0 0 115px;
    }

    .image-container {
        width: 99px;
        height: 132px;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        border-radius: 6px;
        background: #f3f3f3;
    }

    .card-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .col-8 {
        max-height: 155px;
        flex: 1 1 auto;
        min-width: 0;
    }

    .card-body {
        display: flex;
        flex-direction: column;
        padding: 0.1rem;
        height: 100%;
    }

    .card-title {
        font-size: 17px;
        font-weight: 700;
        color: #222;
        margin-bottom: 0;
    }

    .ri {
        display: flex;
        align-items: center;
        font-size: 13px;
        flex-wrap: wrap;
        gap: 12px;
        color: #999;
    }

    .meta-item {
        display: flex;
        align-items: center;
        color: #999;
        font-size: 13px;
    }

    .changlv {
        color: #18b371 !important;
    }

    .content {
        display: flex;
        flex-direction: column;
        margin-top: 0.4rem;
        min-width: 0;
    }

    .card-text {
        margin-bottom: 0.5rem !important;
        font-size: 14px !important;
        color: #666;
        line-height: 1.8;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    .card-link {
        text-decoration: none;
        color: inherit;
        display: block;
        height: 100%;
    }

    .weiz {
        font-size: 14px;
    }

    .pagination-wrap {
        gap: 12px;
        flex-wrap: wrap;
        border-radius: 10px;
    }

    .custom-page-btn {
        min-width: 92px;
        height: 40px;
        border: 1px solid #dcdcdc;
        background: #fff;
        border-radius: 8px;
        color: #555;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.2s ease;
    }

    .custom-page-btn:hover:not(:disabled) {
        border-color: #9ed56a;
        color: #222;
    }

    .custom-page-btn:disabled {
        color: #bbb;
        border-color: #e9e9e9;
        cursor: not-allowed;
        background: #fafafa;
    }

    .page-number-box {
        min-width: 180px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        border: 1px solid #dcdcdc;
        background: #fff;
        border-radius: 8px;
        font-size: 14px;
        color: #555;
    }

    /* PC权限遮罩 */
    .vip-mask-overlay {
        position: fixed;
        inset: 0;
        z-index: 3000;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 32px;
    }

    .pc-list-mask-overlay {
        background:
                linear-gradient(rgba(245, 247, 250, 0.45), rgba(245, 247, 250, 0.45)),
                url("@/assets/weiqunjietu.png") center center / cover no-repeat;
    }

    .pc-list-mask-overlay::before {
        content: "";
        position: absolute;
        inset: 0;
        backdrop-filter: blur(4px);
        -webkit-backdrop-filter: blur(4px);
        background: rgba(255, 255, 255, 0.1);
    }

    .vip-mask-dialog {
        position: relative;
        z-index: 2;
        width: 100%;
        max-width: 520px;
        border-radius: 18px;
        overflow: hidden;
        background: transparent;
        box-shadow: none;
        border: none;
    }

    .vip-mask-content {
        min-height: 320px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 42px 36px;
        text-align: center;
    }

    .vip-mask-badge {
        display: inline-block;
        padding: 6px 14px;
        border-radius: 999px;
        background: linear-gradient(135deg, #f7d774, #e6b84f);
        color: #5b4300;
        font-size: 12px;
        font-weight: 700;
        letter-spacing: 1px;
        margin-bottom: 18px;
    }

    .vip-mask-title {
        font-size: 28px;
        line-height: 1.5;
        color: #111;
        margin-bottom: 10px;
        font-weight: 700;
    }

    .vip-mask-text {
        font-size: 17px;
        line-height: 1.9;
        color: #444;
        margin-bottom: 26px;
        max-width: 390px;
    }

    .mask-link-row {
        display: flex;
        gap: 14px;
        flex-wrap: wrap;
        justify-content: center;
        margin-bottom: 20px;
    }

    .vip-mask-link-btn,
    .vip-upgrade-link-btn {
        min-width: 140px;
        height: 44px;
        line-height: 44px;
        padding: 0 22px;
        border-radius: 24px;
        background: #18b371;
        color: #fff;
        text-decoration: none;
        font-size: 15px;
        transition: all 0.2s ease;
    }

    .vip-mask-link-btn:hover,
    .vip-upgrade-link-btn:hover {
        opacity: 0.92;
        transform: translateY(-1px);
    }

    .vip-mask-link-btn.secondary {
        background: #52a7ff;
    }

    .vip-upgrade-link-btn {
        background: linear-gradient(135deg, #ffb84d, #ff8f2c);
        margin-bottom: 20px;
    }

    .vip-mask-back {
        color: #3aa0ff;
        font-size: 15px;
        cursor: pointer;
        transition: opacity 0.2s ease;
    }

    .vip-mask-back:hover {
        opacity: 0.8;
    }

    /* 详情页 */
    .detail-wrap {
        max-width: 980px;
        margin-left: auto;
        margin-right: auto;
    }

    .detail-card {
        border: 1px solid #eee;
        border-radius: 10px;
        overflow: hidden;
        box-shadow: 0 2px 14px rgba(0, 0, 0, 0.04);
    }

    .detail-title-box {
        padding: 24px 28px 12px;
    }

    .detail-title {
        font-size: 32px;
        margin: 0;
        color: #111;
        font-weight: 700;
    }

    .detail-user-row {
        padding: 0 28px 0;
    }

    .avatar {
        width: 64px;
        height: 64px;
        border-radius: 50%;
        margin-right: 14px;
        object-fit: cover;
    }

    .user-name {
        font-size: 16px;
        color: #666;
    }

    .user-date {
        font-size: 14px;
        color: #aaa;
        margin-top: 4px;
    }

    .collect-btn {
        border: 1px solid #ff9c42;
        color: #ff9c42;
        background: #fff;
        border-radius: 18px;
        padding: 6px 14px;
        min-width: 100px;
    }

    .detail-meta-wrap {
        padding: 18px 28px 8px;
    }

    .detail-meta-item {
        font-size: 15px;
        line-height: 2;
        color: #666;
    }

    .detail-meta-label {
        color: #333;
        font-weight: 600;
    }

    .detail-content {
        padding: 16px 28px 28px;
        font-size: 18px;
        line-height: 2;
        color: #666;
        min-height: 180px;
    }

    .detail-paragraph {
        margin-bottom: 16px;
        text-indent: 2em;
    }

    .copy-share {
        text-align: center;
        color: #1e90ff;
        font-size: 22px;
        padding: 18px 0 24px;
        border-top: 1px solid #f1f1f1;
        cursor: pointer;
        background: #fff;
    }

    .back-btn {
        min-width: 120px;
    }

    /* Toast */
    .toast-box {
        position: fixed;
        left: 50%;
        top: 90px;
        transform: translateX(-50%);
        z-index: 9999;
        min-width: 180px;
        max-width: 320px;
        padding: 12px 18px;
        border-radius: 10px;
        text-align: center;
        color: #fff;
        font-size: 14px;
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.18);
    }

    .toast-box.success {
        background: rgba(0, 194, 111, 0.95);
    }

    .toast-box.error {
        background: rgba(220, 53, 69, 0.95);
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.2s ease;
    }

    .fade-enter-from,
    .fade-leave-to {
        opacity: 0;
    }

    @media (min-width: 768px) {
        .zhai-head {
            position: fixed;
            top: 0;
            width: 100%;
            z-index: 1000;
        }

        .errong {
            margin-top: 90px;
        }
    }
</style>
